import { render, staticRenderFns } from "./TamamlananGorevList.vue?vue&type=template&id=0c44e218"
import script from "./TamamlananGorevList.vue?vue&type=script&lang=ts"
export * from "./TamamlananGorevList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports